import { Cancel, Check, Close, Save } from "@mui/icons-material";
import { CircularProgress, Dialog, DialogActions, DialogTitle } from "@mui/material";
import { Formik } from "formik";
import { isEmpty } from "lodash";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import Api from "../../../api2";
import Helper from "../../../helpers";
import { commonReducerSelector, userSelector } from "../../../redux/selector";
import {
  MyBreadCrumbs,
  MyButton,
  MyForm,
  MyTable,
  MyTextFieldArea,
  MyThaoTac,
  ThongBao,
  scrollToError
} from "../../Lib/componentLibrarys";
import { ValidateSchema } from "./validate";
import { FormNhap } from "./form";
import { parseDataSave, propsToInitialState } from "./models";

const RoutesCoSoSanXuat = [
  {
    path: "",
    main: () => <CoSoSanXuat />
  },
  {
    path: "add",
    main: () => <HandleCoSoSanXuat />
  },
  {
    path: "edit/:id",
    main: () => <HandleCoSoSanXuat />
  }
];
export default RoutesCoSoSanXuat;

function CoSoSanXuat() {
  const [dataFormik, setFormik] = useState({
    search: "",
    limit: 10,
    anchor: 0
  });
  const common = useSelector(commonReducerSelector);
  const profile = common?.profile?.data;
  const [rawData, setRawData] = useState({});
  const [Count, setCount] = useState();
  const [data, setData] = useState([]);
  const [openDiaLog, setOpenDiaLog] = useState(false)
  const [submitDiaLog, setSubmitDiaLog] = useState(false)
  const [selectedData, setSelectedData] = useState(null);
  const [lyDo, setLyDo] = useState('')
  const formikRef = useRef();
  //for table method
  const navigate = useNavigate();

  const parseSearchForm = values => {
    const tuKhoa = values?.search?.length > 0 ? values?.search : "";
    const limit = values?.limit ? values.limit : 10;
    const anchor = values?.anchor ? values.anchor : 0;
    const page = values?.page || "";
    return { tuKhoa, limit, anchor, page };
  };

  useEffect(() => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  }, []);
  const getRows = (limit, anchor, page) => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm({ ...values, limit, anchor, page }));
  };

  const handleActivate = (data) => {
    setSelectedData(data);
    setOpenDiaLog(true);
  };
  
  useEffect(() => {
    if (submitDiaLog && selectedData) {
      const submitData = {
        id: selectedData?.id,
        lock_Unlock: selectedData?.isLock ? false : true,
        lyDo: lyDo
      };
      new Api()
        .LockCoSoSanXuat({ data: submitData })
        .then((res) => {
            if (!res || res.code !== 200) {
                ThongBao({ status: 'error', message: 'Đã có lỗi xảy ra' });
                return;
            }
            getApi(parseSearchForm(formikRef.current.values));
            ThongBao({ status: 'success', message: `${selectedData?.isLock ? 'Mở khóa' : 'Khóa' } thành công` });
        })
        .catch((err) => {
            ThongBao({ status: 'error', message: 'Đã có lỗi xảy ra' });
        })
        .finally(() => {
            setSubmitDiaLog(false);
            setSelectedData(null);
        });
    }
  }, [submitDiaLog]);

  const getApi = ({ tuKhoa, limit, anchor, page }) => {
    new Api()
      .GetListCoSoSanXuat({ tuKhoa, limit, anchor })
      .then(res => {
        if (res.code === 200) {
          setData(
            Helper.addSttToTableDataSource(res.data.records, page, limit)
          );
          setRawData(res.data);
        }
        if (res.data?.count) {
          setCount(res.data?.count);
        }
      })
      .catch(err => {});
  };
  const onSubmitSearch = () => {
    const values = formikRef.current?.values;
    getApi(parseSearchForm(values));
  };
  const columns = ({ handleEdit, handleDelete }) => {
    var column = [
      {
        headerName: "STT",
        field: "stt",
        width: "100px",
        suppressSizeToFit: true,
        pinned: "left",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center"
      },
      { headerName: "Tên cơ sở", field: "tenCoSoSanXuat", width: "300px" },
      { headerName: "Người đại diện", field: "nguoiDaiDien", width: "250px" },
      { headerName: "Điện thoại", field: "dienThoai", width: "200px" },
      { headerName: "Địa chỉ", field: "diaChi", width: "200px" },
      {
        headerName: "Tình trạng hoạt động",
        width: "200px",
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRendererFramework: params => {
          let returnStatus = (
            <div className="tableList-button-ngungHoatDong">Dừng hoạt động</div>
          );
          if (params?.data?.tinhTrangHoatDong === true) {
            returnStatus = (
              <div className="tableList-button-dangHoatDong">
                Đang hoạt động
              </div>
            );
          }
          return returnStatus;
        }
      },
      {
        headerName: "Trạng thái khóa",
        minWidth: 200,
        flex: 1,
        cellStyle: { justifyContent: "center" },
        headerClass: "ag-grid-header-center",
        cellRendererFramework: params => {
          let returnStatus = (
            <div className="tableList-button-dangHoatDong">
              Bình thường
            </div>
          );
          if (params?.data?.isLock === true) {
            returnStatus = (
              <div className="tableList-button-ngungHoatDong">Đang bị khóa</div>
            );
          }
          return returnStatus;
        }
      },
      {
        headerName: "Thao tác",
        width: "100px",
        pinned: "right",
        cellStyle: { justifyContent: "center" },
        cellRendererFramework: prams => (
          <MyThaoTac
            prams={prams}
            handleDelete={handleDelete}
            handleEdit={handleEdit}
            handleActivate={profile?.cap === 0 && handleActivate}
            isActivated={!prams?.data?.isLock}
          />
        ),
        headerClass: "ag-grid-header-center"
      }
    ];
    return column;
  };

  const handleEdit = params => {
    if (!params?.id) {
      ThongBao({ status: "warn", message: "ID không tồn tại" });
    }
    navigate(`edit/${params?.id || undefined}`);
  };
  const handleAdd = data => {
    navigate(`add`);
  };
  const handleDelete = params => {
    new Api()
      .DeleteCoSoSanXuatById({ id: params?.id })
      .then(res => {
        if (res.code === 200) {
          const values = formikRef.current.values;
          getApi(parseSearchForm(values));
          ThongBao({ status: "success", message: "Xóa thành công" });
        }
      })
      .catch(err => {});
  };

  return (
    <div className="divMain">
      <MyBreadCrumbs
        title={[{ name: "Thông tin sản xuất" }, { name: "Cơ sở sản xuất" }]}
      />
      <MyForm
        formikRef={formikRef}
        showSearch={true}
        dataFormik={dataFormik}
        handleAdd={handleAdd}
        editable={true}
        onSubmitAPI={onSubmitSearch}
        marginBottom={"15px"}
      />
      <MyTable
        autofit={true}
        columns={columns({
          editable: true,
          handleEdit: handleEdit,
          handleDelete: handleDelete
        })}
        data={data}
        pagination={{
          rawData: rawData,
          setData: setData,
          getRows: getRows,
          Count: Count
        }}
      />
      <Dialog
        open={openDiaLog} 
        onClose={() => setOpenDiaLog(false)} 
        aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle className="capPhep-listInput-dialog-title" style={{ width: 400 }}>Lý do khóa/mở khóa</DialogTitle>
          <div style={{ marginLeft: 10, marginRight: 10 }}>
            <MyTextFieldArea
              placeholder="Nhập..."
              maxRows={3}
              rows={3}
              value={lyDo}
              onChange={(e) => {
                setLyDo(e?.target?.value)
              }}
            />
          </div>
          <DialogActions className="capPhep-listInput-dialog-content" style={{ display: 'flex', justifyContent: 'center' }}>
              <MyButton onClick={() => setOpenDiaLog(false)} txt="Hủy bỏ" color="rgb(122, 122, 122)" className="capPhep-listInput-dialog-buttonClose" icon={<Close />} />
              <MyButton
                  onClick={() => {
                    setOpenDiaLog(false)
                    setSubmitDiaLog(true)
                  }}
                  txt="Xác nhận"
                  className="capPhep-listInput-dialog-buttonCheck"
                  icon={<Check />}
              />
          </DialogActions>
      </Dialog>
    </div>
  );
}

function HandleCoSoSanXuat() {
  const navigate = useNavigate();
  const user = useSelector(userSelector);
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [data, setData] = useState(null);
  const common = useSelector(commonReducerSelector);
  const dataDanhMuc = common?.danhmucs?.data;
  const formRef = useRef(null);

  //ref just for use scroll when error validate
  const refI = useRef(null);

  useEffect(() => {
    if (id && !data) {
      setIsLoading(true);
      new Api()
        .GetCoSoSanXuatById({ id: id })
        .then(data => {
          if (data.code === 200) {
            setData(data?.data);
          }
        })
        .catch(err => {})
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [id]);

  if (isLoading) {
    return (
      <div className="style-loading">
        <CircularProgress />
      </div>
    );
  }

  //set initial data
  const initialState = propsToInitialState(data);

  //List form
  const formNhap = (
    <Formik
      innerRef={f => (formRef.current = f)}
      i
      initialValues={initialState}
      enableReinitialize={true}
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={ValidateSchema}
    >
      {({ values, errors, handleSubmit, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          {/* div just for use scroll when error validate */}
          <div ref={refI}></div>
          <FormNhap
            values={values}
            errors={errors}
            setFieldValue={setFieldValue}
          />
        </form>
      )}
    </Formik>
  );

  //handle when submit API
  const handleSave = async () => {
    await formRef.current.validateForm();

    if (!isEmpty(formRef.current.errors)) {
      scrollToError(refI);
      ThongBao({
        status: "warn",
        message: "Yêu cầu nhập đầy đủ các trường có dấu đỏ"
      });
      return;
    }

    new Api()
      .UpsertCoSoSanXuat({
        token: user.access_token,
        data: parseDataSave(formRef.current.values)
      })
      .then(res => {
        if (!res || res.code !== 200) {
          //TODO
          ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
          return;
        }
        ThongBao({ status: "success", message: res?.data });
        navigate(-1);
      })
      .catch(err => {
        ThongBao({ status: "error", message: "Đã có lỗi xảy ra" });
      })
      .finally(() => {});
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          paddingBottom: "0.875rem"
        }}
      >
        <MyBreadCrumbs
          title={[
            { name: "Thông tin sản xuất" },
            { name: "Cơ sở sản xuất", link: -1 },
            { name: `${id ? "Cập nhật " : "Thêm mới"}` }
          ]}
        />
        {formNhap}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: 15
        }}
      >
        <MyButton
          onClick={() => navigate(-1)}
          txt="Hủy bỏ"
          color="#888"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Cancel />}
        />
        <p style={{ width: 5 }}></p>
        <MyButton
          onClick={() => {
            handleSave();
          }}
          txt="Lưu thông tin"
          style={{ width: 130, height: 33, marginTop: 5 }}
          icon={<Save />}
        />
      </div>
    </>
  );
}
